// import React, { useState } from 'react';
// import {
//   Drawer, List, ListItemButton, ListItemIcon, ListItemText,
//   Avatar, Typography, Box, IconButton, Tooltip, Divider
// } from '@mui/material';
// import {
//   Dashboard, People, Settings, Logout, Menu as MenuIcon, ChevronLeft
// } from '@mui/icons-material';
// import { NavLink, useNavigate } from 'react-router-dom';
// import { motion } from 'framer-motion';
// // import handleLogout from '../utils/handleLogout';
// import handleLogout from '../Admin-Dashboard-Component/Comman/handleLogout';

// const drawerWidth = 240;

// const menuItems = [
//   { label: 'Dashboard', icon: <Dashboard />, path: '/admin/dashboard' },
//   { label: 'Users', icon: <People />, path: '/admin/users' },
//   { label: 'Settings', icon: <Settings />, path: '/admin/settings' },
// ];

// const AdminSidebar = () => {
//   const [open, setOpen] = useState(true);
//   const navigate = useNavigate();

//   return (
//     <motion.div
//       initial={{ width: 0 }}
//       animate={{ width: open ? drawerWidth : 70 }}
//       transition={{ duration: 0.3 }}
//       style={{ height: '100vh', overflowX: 'hidden', position: 'fixed', top: 0, left: 0, zIndex: 1200 }}
//     >
//       <Drawer
//         variant="permanent"
//         open={open}
//         sx={{
//           '& .MuiDrawer-paper': {
//             background: 'linear-gradient(to bottom, #1a237e, #283593)',
//             color: '#fff',
//             width: open ? drawerWidth : 70,
//             transition: 'width 0.3s',
//             overflowX: 'hidden',
//             boxSizing: 'border-box',
//             borderRight: 'none'
//           },
//         }}
//       >
//         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: open ? 'space-between' : 'center', p: 2 }}>
//           {open && (
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//               <Avatar sx={{ width: 32, height: 32 }}>A</Avatar>
//               <Typography variant="body1" fontWeight={600}>Admin</Typography>
//             </Box>
//           )}
//           <IconButton onClick={() => setOpen(!open)} sx={{ color: '#fff' }}>
//             {open ? <ChevronLeft /> : <MenuIcon />}
//           </IconButton>
//         </Box>

//         <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)' }} />

//         <List>
//           {menuItems.map((item) => (
//             <NavLink
//               key={item.label}
//               to={item.path}
//               style={({ isActive }) => ({
//                 textDecoration: 'none',
//                 color: isActive ? '#fff' : '#c5cae9',
//               })}
//             >
//               <ListItemButton
//                 sx={{
//                   py: 1.5,
//                   px: open ? 2 : 1,
//                   '&:hover': {
//                     backgroundColor: 'rgba(255,255,255,0.08)',
//                   }
//                 }}
//               >
//                 <Tooltip title={open ? '' : item.label} placement="right">
//                   <ListItemIcon sx={{ color: '#fff', minWidth: 0, mr: open ? 2 : 'auto', justifyContent: 'center' }}>
//                     {item.icon}
//                   </ListItemIcon>
//                 </Tooltip>
//                 {open && <ListItemText primary={item.label} />}
//               </ListItemButton>
//             </NavLink>
//           ))}
//         </List>

//         <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)' }} />

//         <ListItemButton
//           onClick={() => handleLogout(() => navigate('/login'))}
//           sx={{ color: '#fff', mt: 'auto', py: 1.5 }}
//         >
//           <ListItemIcon sx={{ color: '#fff', minWidth: 0, mr: open ? 2 : 'auto', justifyContent: 'center' }}>
//             <Logout />
//           </ListItemIcon>
//           {open && <ListItemText primary="Logout" />}
//         </ListItemButton>
//       </Drawer>
//     </motion.div>
//   );
// };

// export default AdminSidebar;




import React, { useState } from 'react';
import { menuItems } from './SidebarMenuItems';
import {
    Drawer, List, ListItemButton, ListItemIcon, ListItemText,
    Avatar, Typography, Box, IconButton, Tooltip, Divider
} from '@mui/material';
import {
    Dashboard, People, Settings, Logout, Menu as MenuIcon,
    ChevronLeft, Article, LibraryBooks, Category,
    Assignment, Quiz, AssignmentTurnedIn, FactCheck, LibraryAddCheck
} from '@mui/icons-material';
import { NavLink, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import handleLogout from '../Admin-Dashboard-Component/Comman/handleLogout';

const drawerWidth = 240;

const AdminSidebar = () => {
    const [open, setOpen] = useState(true);
    const navigate = useNavigate();

    return (
        <motion.div
            initial={{ width: 0 }}
            animate={{ width: open ? drawerWidth : 70 }}
            transition={{ duration: 0.35 }}
            style={{ height: '100vh', overflowX: 'hidden', position: 'fixed', top: 0, left: 0, zIndex: 1200 }}
        >
            <Drawer
                variant="permanent"
                open={open}
                sx={{
                    '& .MuiDrawer-paper': {
                        background: 'linear-gradient(to bottom, #e3f2fd, #bbdefb)',
                        color: '#333',
                        width: open ? drawerWidth : 70,
                        transition: 'width 0.3s',
                        overflowX: 'hidden',
                        boxSizing: 'border-box',
                        borderRight: 'none',
                    },
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: open ? 'space-between' : 'center', p: 2 }}>
                    {open && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Avatar sx={{ bgcolor: '#f1c40f', color: '#000' }}>A</Avatar>
                            <Typography variant="body1" fontWeight={600}>Admin</Typography>
                        </Box>
                    )}
                    <IconButton onClick={() => setOpen(!open)} sx={{ color: '#f1c40f' }}>
                        {open ? <ChevronLeft /> : <MenuIcon />}
                    </IconButton>
                </Box>

                <Divider sx={{ borderColor: 'rgba(0,0,0,0.1)' }} />

                <List>
                    {menuItems.map((item, index) => (
                        <NavLink
                            key={item.label}
                            to={item.path}
                            style={({ isActive }) => ({
                                textDecoration: 'none',
                                color: isActive ? '#f1c40f' : '#333',
                                fontWeight: isActive ? 'bold' : 'normal',
                            })}
                        >
                            <motion.div
                                initial={{ opacity: 0, x: -20 }}
                                animate={{ opacity: 1, x: 0 }}
                                transition={{ delay: index * 0.1 }}
                                whileHover={{ scale: 1.06 }}
                                whileTap={{ scale: 0.97 }}
                            >
                                <ListItemButton
                                    sx={{
                                        py: 1.6,
                                        px: open ? 2 : 1.5,
                                        borderRadius: 2,
                                        mx: 1,
                                        '&:hover': {
                                            backgroundColor: 'rgba(255, 235, 59, 0.2)',
                                            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                                        },
                                    }}
                                >
                                    <Tooltip title={open ? '' : item.label} placement="right">
                                        <ListItemIcon sx={{ color: '#f1c40f', minWidth: 0, mr: open ? 2 : 'auto', justifyContent: 'center' }}>
                                            {item.icon}
                                        </ListItemIcon>
                                    </Tooltip>
                                    {open && (
                                        <motion.div
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{ delay: 0.1 }}
                                        >
                                            <ListItemText primary={item.label} />
                                        </motion.div>
                                    )}
                                </ListItemButton>
                            </motion.div>
                        </NavLink>
                    ))}
                </List>

                <Divider sx={{ borderColor: 'rgba(0,0,0,0.1)' }} />

                <motion.div
                    whileHover={{ scale: 1.04 }}
                    whileTap={{ scale: 0.96 }}
                >
                    <ListItemButton
                        onClick={() => handleLogout(() => navigate('/admin-login'))}
                        sx={{
                            color: '#e53935',
                            mt: 'auto',
                            py: 1.6,
                            mx: 1,
                            borderRadius: 2,
                            '&:hover': {
                                backgroundColor: 'rgba(229, 57, 53, 0.1)',
                                boxShadow: '0 4px 8px rgba(229, 57, 53, 0.2)',
                            }
                        }}
                    >
                        <ListItemIcon
                            sx={{
                                color: '#e53935',
                                minWidth: 0,
                                mr: open ? 2 : 'auto',
                                justifyContent: 'center'
                            }}
                        >
                            <Logout />
                        </ListItemIcon>
                        {open && <ListItemText primary="Logout" />}
                    </ListItemButton>

                </motion.div>
            </Drawer>
        </motion.div>
    );
};

export default AdminSidebar;
